import * as React from "react";
import type { SVGProps } from "react";
const SvgBotIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="bot_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M298.667 85.333A42.667 42.667 0 0 0 256 128v27.52A149.675 149.675 0 0 0 155.52 256H128a42.667 42.667 0 0 0 0 85.333h27.52A149.675 149.675 0 0 0 256 441.813v140.374a149.675 149.675 0 0 0-100.48 100.48H128A42.667 42.667 0 1 0 128 768h27.52A149.675 149.675 0 0 0 256 868.48V896a42.667 42.667 0 1 0 85.333 0v-27.52A149.675 149.675 0 0 0 441.813 768h140.374a149.675 149.675 0 0 0 100.48 100.48V896A42.667 42.667 0 1 0 768 896v-27.52A149.675 149.675 0 0 0 868.48 768H896a42.667 42.667 0 1 0 0-85.333h-27.52A149.675 149.675 0 0 0 768 582.187V441.813a149.675 149.675 0 0 0 100.48-100.48H896A42.667 42.667 0 1 0 896 256h-27.52A149.675 149.675 0 0 0 768 155.52V128a42.667 42.667 0 1 0-85.333 0v27.52A149.675 149.675 0 0 0 582.187 256H441.813a149.675 149.675 0 0 0-100.48-100.48V128a42.667 42.667 0 0 0-42.666-42.667zm42.666 356.48a149.675 149.675 0 0 0 100.48-100.48h140.374a149.675 149.675 0 0 0 100.48 100.48v140.374a149.675 149.675 0 0 0-100.48 100.48H441.813a149.675 149.675 0 0 0-100.48-100.48V441.813zm-42.666 219.52a64 64 0 1 1 0 128 64 64 0 0 1 0-128zm362.666 64a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm64-490.666a64 64 0 1 1 0 128 64 64 0 0 1 0-128zm-490.666 64a64 64 0 1 1 128 0 64 64 0 0 1-128 0z"
    />
  </svg>
);
export default SvgBotIcon;
